import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import type { GetVerifyUserIdResponse } from 'viewup-api/v2';

export const getVerifyUserId = async (id: string): Promise<GetVerifyUserIdResponse> => {
  const response = await serviceApi.auth.getVerifyUserId(withServiceRequestDefaults({ id }));
  return response.data;
};
